import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // SHOW loading state while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'var(--font-primary)',
        color: 'var(--color-text-primary)',
      }}>
        <p>Authentifizierung wird überprüft...</p>
      </div>
    );
  }

  // REDIRECT to join page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // RENDER protected content
  return <>{children}</>;
};
